import { render, staticRenderFns } from "./CompanyBase.vue?vue&type=template&id=c053f30e&scoped=true&"
import script from "./CompanyBase.vue?vue&type=script&lang=js&"
export * from "./CompanyBase.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBase.vue?vue&type=style&index=0&id=c053f30e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c053f30e",
  null
  
)

export default component.exports